import { render } from "./DetailPage.vue?vue&type=template&id=bd509952&ts=true"
import script from "./DetailPage.vue?vue&type=script&lang=ts"
export * from "./DetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__